import { render, staticRenderFns } from "./baiberk-details.vue?vue&type=template&id=2ba69356&"
import script from "./baiberk-details.vue?vue&type=script&lang=js&"
export * from "./baiberk-details.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports